import { forwardRef } from "react";

import type { SVGIconProps } from "../types";

export const PortUsbTypeCIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_315"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_315)">
        <path
          d="M4.18182 7.36369H11.8182C12.1682 7.36369 12.4545 7.65006 12.4545 8.00006C12.4545 8.35006 12.1682 8.63642 11.8182 8.63642H4.18182C3.83182 8.63642 3.54545 8.35006 3.54545 8.00006C3.54545 7.65006 3.83182 7.36369 4.18182 7.36369ZM4.18182 6.09096C3.12545 6.09096 2.27273 6.94369 2.27273 8.00006C2.27273 9.05642 3.12545 9.90915 4.18182 9.90915H11.8182C12.8745 9.90915 13.7273 9.05642 13.7273 8.00006C13.7273 6.94369 12.8745 6.09096 11.8182 6.09096H4.18182ZM4.18182 4.81824H11.8182C13.5745 4.81824 15 6.24369 15 8.00006C15 9.75642 13.5745 11.1819 11.8182 11.1819H4.18182C2.42545 11.1819 1 9.75642 1 8.00006C1 6.24369 2.42545 4.81824 4.18182 4.81824Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortUsbTypeCIcon.displayName = "PortUsbTypeCIcon";
